import { UserManagementList } from './list'
import { UserManagementAddUser } from './addUser'
import Detail from './detail'

export { UserManagementList, UserManagementAddUser, Detail }



// WEBPACK FOOTER //
// ./src/report-app/pages/usersManagement/index.js